module.exports = __webpack_public_path__ + "img/pmed-logo-no-bg.c8979a5e.png";